import type { track as TrackFunction } from "pro-features/components/WithTrack/src/context";

const createMyListTrackingService = (track: TrackFunction) => {
    return {
        trackTabsOptionsClicked(tabName: string) {
            track("my lists", "click", `switch tabs/${tabName}`);
        },
        trackSearchInTab(tabName: string) {
            track("my lists", "search", tabName);
        },
    };
};

export default createMyListTrackingService;
